module.exports = __webpack_public_path__ + "static/yayas.08aaf4c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/yayas.jpg
// module id = 636
// module chunks = 262104617495404